module.exports = __webpack_public_path__ + "static/media/AB_K25_1.87eb95b8.jpg";